/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const userDirectoryDetailResponseOutputUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const userDirectoryDetailResponseOutputUserDisplayNameMax = 200;

export const userDirectoryDetailResponseOutputUserVersionExclusiveMin = 0;
export const userDirectoryDetailResponseOutputUserVersionMax = 9007199254740991;

export const userDirectoryDetailResponseOutputUserMembershipCountMin = 0;
export const userDirectoryDetailResponseOutputUserMembershipCountMax = 9007199254740991;

export const userDirectoryDetailResponseOutputMembershipsItemsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const userDirectoryDetailResponseOutputMembershipsItemsItemTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const userDirectoryDetailResponseOutputMembershipsItemsItemUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const userDirectoryDetailResponseOutputMembershipsItemsItemDisplayNameMax = 200;

export const userDirectoryDetailResponseOutputMembershipsItemsItemStartedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const userDirectoryDetailResponseOutputMembershipsItemsItemEndedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const userDirectoryDetailResponseOutputMembershipsItemsItemVersionExclusiveMin = 0;
export const userDirectoryDetailResponseOutputMembershipsItemsItemVersionMax = 9007199254740991;

export const userDirectoryDetailResponseOutputMembershipsNextCursorOneMax = 512;

export const userDirectoryDetailResponseOutputMembershipsNextCursorOneRegExp = new RegExp(
  '^[A-Za-z0-9_-]+$',
);

export const UserDirectoryDetailResponseOutput = zod.object({
  user: zod.object({
    id: zod.uuid().regex(userDirectoryDetailResponseOutputUserIdRegExp),
    displayName: zod.string().min(1).max(userDirectoryDetailResponseOutputUserDisplayNameMax),
    corporateState: zod.enum(['active', 'deactivated']),
    role: zod.union([zod.enum(['Agent', 'Admin']), zod.null()]),
    version: zod
      .int()
      .gt(userDirectoryDetailResponseOutputUserVersionExclusiveMin)
      .max(userDirectoryDetailResponseOutputUserVersionMax),
    membershipCount: zod
      .int()
      .min(userDirectoryDetailResponseOutputUserMembershipCountMin)
      .max(userDirectoryDetailResponseOutputUserMembershipCountMax),
  }),
  memberships: zod.object({
    items: zod.array(
      zod.object({
        id: zod.uuid().regex(userDirectoryDetailResponseOutputMembershipsItemsItemIdRegExp),
        teamId: zod.uuid().regex(userDirectoryDetailResponseOutputMembershipsItemsItemTeamIdRegExp),
        userId: zod.uuid().regex(userDirectoryDetailResponseOutputMembershipsItemsItemUserIdRegExp),
        displayName: zod
          .string()
          .min(1)
          .max(userDirectoryDetailResponseOutputMembershipsItemsItemDisplayNameMax),
        startedAt: zod.iso
          .datetime({ offset: true })
          .regex(userDirectoryDetailResponseOutputMembershipsItemsItemStartedAtRegExp),
        endedAt: zod.union([
          zod.iso
            .datetime({ offset: true })
            .regex(userDirectoryDetailResponseOutputMembershipsItemsItemEndedAtOneRegExp),
          zod.null(),
        ]),
        version: zod
          .int()
          .gt(userDirectoryDetailResponseOutputMembershipsItemsItemVersionExclusiveMin)
          .max(userDirectoryDetailResponseOutputMembershipsItemsItemVersionMax),
        teamActive: zod.boolean(),
        effective: zod.boolean(),
      }),
    ),
    nextCursor: zod.union([
      zod
        .string()
        .min(1)
        .max(userDirectoryDetailResponseOutputMembershipsNextCursorOneMax)
        .regex(userDirectoryDetailResponseOutputMembershipsNextCursorOneRegExp),
      zod.null(),
    ]),
  }),
});

export type UserDirectoryDetailResponseOutput = zod.input<typeof UserDirectoryDetailResponseOutput>;
export type UserDirectoryDetailResponseOutputOutput = zod.output<
  typeof UserDirectoryDetailResponseOutput
>;
